<template>
  <div id="main_frame">
    <router-view />
  </div>
</template>
<script lang="ts" setup>
import { onMounted } from "vue";
import store from "./store";
import { loadTranslations } from "@/composables/useTranslation";
import { loadProtocolText } from "@/composables/useProtocolText";

onMounted(async () => {
  await store.dispatch("auth/verifyToken");
  // 加载翻译表到内存缓存（设备名英文转中文展示用）
  loadTranslations();
  // 加载协议 TEXT 枚举映射到内存缓存（工况/电池状态等枚举值翻译用）
  loadProtocolText();
});
</script>
<style lang="less">
h1 {
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-shadow: 1px 1px 2px rgb(249, 204, 255);
  font-size: 26px;
}
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
